var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 140,
    viewBox: "0 0 180 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.4381,
    cy: 98.8085,
    r: 3.17084,
    transform: "rotate(-23.205 56.4381 98.8085)",
    fill: "#E4966A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.776,
    cy: 41.9967,
    r: 1.76158,
    transform: "rotate(-23.205 113.776 41.9967)",
    fill: "#009B81"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.111,
    cy: 30.2383,
    r: 2.46621,
    transform: "rotate(-23.205 116.111 30.2383)",
    fill: "#E4966A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.018,
    cy: 33.7615,
    r: 2.46621,
    transform: "rotate(-23.205 102.018 33.7615)",
    fill: "#E4966A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5232,
    cy: 93.2355,
    r: 3.52315,
    fill: "#009B81"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.036,
    cy: 88.6557,
    r: 2.46621,
    fill: "#009B81"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.829 78.8526C126.745 83.635 128.6 89.777 127.987 95.9274C127.374 102.078 124.343 107.733 119.561 111.648C114.778 115.564 108.636 117.419 102.486 116.806C96.3357 116.193 90.6807 113.162 86.7651 108.38",
    stroke: "#009B81",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.858 80.1291H77.68V59.8357H87.858C90.5573 59.8357 93.1461 60.9048 95.0549 62.8076C96.9636 64.7105 98.0359 67.2913 98.0359 69.9824C98.0359 72.6735 96.9636 75.2543 95.0549 77.1572C93.1461 79.0601 90.5573 80.1291 87.858 80.1291ZM82.769 64.9091V75.0557H87.858C89.2076 75.0557 90.502 74.5212 91.4564 73.5698C92.4108 72.6184 92.9469 71.3279 92.9469 69.9824C92.9469 68.6369 92.4108 67.3464 91.4564 66.395C90.502 65.4436 89.2076 64.9091 87.858 64.9091H82.769ZM95.4914 49.6891H70.0465V90.2757H105.669V59.8357H95.4914V49.6891ZM64.9575 47.1321C64.9575 45.742 66.0949 44.6157 67.4995 44.6157H98.0359L110.758 57.2991V92.7947C110.761 93.1278 110.697 93.4581 110.572 93.7668C110.446 94.0754 110.26 94.3564 110.026 94.5936C109.791 94.8308 109.512 95.0196 109.204 95.1492C108.896 95.2788 108.566 95.3468 108.232 95.3491H67.4842C66.816 95.3444 66.1764 95.0779 65.7036 94.6071C65.2308 94.1362 64.9628 93.4989 64.9575 92.8327V47.1321Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.1d15dff1d6a70dc1d2f39a88a43c6d64.svg";
export { ForwardRef as ReactComponent };